import { createContext } from 'react';

import RootStore, { IRootStore } from './root-store';
import initAxios from '../config/axios';
import RtmStoreSingleton from '../hooks/useRTM/store';

export const storeContext = createContext<{ store:IRootStore,reset:()=>void }>({store:{} as IRootStore,reset:()=>{}} );

interface IStoreProviderProps {
  children: React.ReactNode;
}
class RootStoreSingleton {
  private static instance: RootStore;

  static getInstance(): RootStore {
    if (!RootStoreSingleton.instance) {
      RootStoreSingleton.instance = new RootStore();
    }
    return RootStoreSingleton.instance;
  }
  static resetInstance(){
    RootStoreSingleton.instance = new RootStore();
  }
}
export default function StoreProvider({ children }: IStoreProviderProps) {
  const store = RootStoreSingleton.getInstance();

  const reset = ()=>{
    RtmStoreSingleton.resetInstance();
    RootStoreSingleton.resetInstance();
  }

  initAxios(store);

  return (
    <storeContext.Provider value={{ store,reset }}>{children}</storeContext.Provider>
  );
}
